module.exports = __webpack_public_path__ + "static/img/img-motor-color-2.92b734a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-motor-color-2.png
// module id = jNg9
// module chunks = 36